import { HttpClient, HttpParams } from '@angular/common/http';
import { endpoints } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { LimiteTipoPeriodo, LimitTipo } from '../limits/models/limits';

interface TimeRangeType {
  HorarioInicial: string;
  HorarioFinal: string;
  PrazoCompensacao: string;
  TipoTransacaoDisponivel: string;
}

interface LimitReturnType {
  ValorMaximoPorDia: number;
  LimitarValorMaximoPorDia: boolean;
  ValorPorDia: number;
  LimitarValorPorDia: boolean;
  ValorMaximoPorTransacao: number;
	ValorMinimoPorTransacao: number;
  ValorPorTransacao: number;
  TempoEsgotado: number;
  Tipo: string;
  ProximoDiaUtil: string;
  DiaUtilHoje: boolean;
  FaixaHorario: TimeRangeType;
}

interface LimitResponseDataType {
  Tipo: string;
  Retorno: LimitReturnType[];
  Sucesso: boolean;
  Existe: boolean;
  Mensagem: string;
}

@Injectable()
export class DepositPerTicketService {

	constructor(private http: HttpClient) { }

	getTicket(value: number): Observable<any> {

		const data = {
			Valor: value
		};

		return this.http.post(endpoints.deposits.ticket, data ).pipe( map( (data: any) => {

			return data;

		}));

	}

	getLimitsDeposit(): Observable<any> {

		let limits = {};

		const params = new HttpParams()
			.set('tipoLimite', LimitTipo.REGISTRO_BOLETOS);

		return this.http.get( endpoints.accounts.limits, { params } ).pipe(map((data: LimitResponseDataType) => {
			if (data.Sucesso) {
				data.Retorno.map(item => {
					if (item.Tipo === LimiteTipoPeriodo.DEPOSITO_POR_BOLETO_DIURNO) {
						limits = {
							min: item.ValorMinimoPorTransacao,
							max: item.ValorMaximoPorTransacao,
							isLimitedValue: item.LimitarValorPorDia,
						}
					}
				});
			}
			return limits;
		}));
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/deposit-per-ticket/deposit-per-ticket.service.ts